var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    { attrs: { id: "delegationModal", "hide-footer": true } },
    [
      _c(
        "div",
        { attrs: { id: "delegationForm" } },
        [
          _c(
            "div",
            { staticClass: "formTitle" },
            [
              _c("svg-image", { attrs: { image: "iconDelegate" } }),
              _vm._v(" "),
              _c("h5", [_vm._v(_vm._s(_vm.$t("delrpc.head")))]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "groupLabel" }, [
            _c("label", [_vm._v(_vm._s(_vm.$t("delrpc.lform")))]),
          ]),
          _vm._v(" "),
          _c(
            "b-form",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "",
                    label: _vm.$t("delrpc.fname"),
                    "label-for": "",
                    description: _vm.$t("delrpc.fnamedesc"),
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: { id: "name", required: "", placeholder: "" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "",
                    label: _vm.$t("delrpc.femail"),
                    "label-for": "",
                    description: _vm.$t("delrpc.femaildesc"),
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: { id: "email", type: "email", required: "" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "phone-group",
                    label: _vm.$t("delrpc.fphone"),
                    "label-for": "phone",
                    description: "",
                  },
                },
                [
                  _c(
                    "b-form-group",
                    { attrs: { id: "phone-group", "label-for": "phone" } },
                    [
                      _c("VuePhoneNumberInput", {
                        staticClass: "form-group",
                        attrs: {
                          color: "#ea0c0c",
                          "border-radius": 0,
                          required: "",
                          "default-country-code": "ID",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-checkbox",
                {
                  attrs: {
                    id: "acceptance",
                    name: "acceptance",
                    value: "accepted",
                    "unchecked-value": "not_accepted",
                  },
                },
                [
                  _c("div", {
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("delrpc.facceptance")),
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "clearfix" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        block: "",
                        type: "submit",
                        variant: "primary",
                        size: "lg",
                      },
                    },
                    [
                      _c("b-spinner", { attrs: { small: "", type: "grow" } }),
                      _vm._v(" " + _vm._s(_vm.$t("delrpc.btn"))),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/components/DelegationModal.vue